// This file is generated by next-core EcmascriptClientReferenceModule.
const { createClientModuleProxy } = require("react-server-dom-turbopack/server");

__turbopack_context__.n(createClientModuleProxy("[project]/frontend/node_modules/next/dist/client/components/builtin/global-error.js <module evaluation>"));
